import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

const HOW_ITEMS = [
  { icon: 'ri-money-dollar-circle-line', key: 'how1' },
  { icon: 'ri-check-double-line', key: 'how2' },
  { icon: 'ri-folder-transfer-line', key: 'how3' },
  { icon: 'ri-eye-line', key: 'how4' },
  { icon: 'ri-chat-smile-2-line', key: 'how5' },
];

export default function HowWeWork() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 bg-[#F7F8FA]">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-50 text-primary-700 text-xs font-semibold tracking-wider uppercase mb-4">
              {t('trafficPro.howTag')}
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
              {t('trafficPro.howTitle')}{' '}
              <span className="text-primary-500">{t('trafficPro.howTitleHighlight')}</span>
            </h2>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {HOW_ITEMS.map((item, i) => (
            <ScrollReveal key={item.key} delay={i * 0.08}>
              <div className="group bg-white border border-gray-100 rounded-2xl p-6 text-center hover:border-primary-200 hover:shadow-[0_8px_32px_rgba(0,0,0,0.05)] hover:-translate-y-1 transition-all duration-400 h-full flex flex-col items-center">
                <div className="w-14 h-14 rounded-2xl bg-primary-50 flex items-center justify-center mb-5 group-hover:bg-primary-100 group-hover:scale-110 transition-all duration-300">
                  <i className={`${item.icon} text-primary-500 text-2xl`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                  {t(`trafficPro.${item.key}Title`)}
                </h3>
                <p className="text-foreground-600 text-xs leading-relaxed">
                  {t(`trafficPro.${item.key}Desc`)}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}